import { FunctionalComponent, h } from '@stencil/core';
import { AppLink, AppRTE, AppMedia } from './'

interface AppAd {
    Title: string;
    Description: any;
    Media: any;
    Link: any;
}


export const AppAd: FunctionalComponent<AppAd> = ({ Title, Description, Link, Media }) => {

    return (
        <div class='uk-background-primary-light uk-position-relative uk-light uk-grid-collapse' uk-grid>
            <div class="uk-width-1-3 uk-cover-container">
                <AppMedia className='uk-width-1-1' media={Media} cover />
            </div>
            <div class='uk-width-2-3 uk-padding-large uk-position-relative'>
                <h3 class="uk-heading-medium wsio-darker-green uk-text-uppercase uk-margin-remove-bottom">{Title}</h3>
                <AppRTE markdown={Description} />
                <AppLink className='uk-button uk-button-default uk-navbar-dropdown-close' data={Link} />
            </div>
        </div >
    )
};


